import { render, staticRenderFns } from "./config.vue?vue&type=template&id=027a89a8&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=027a89a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a89a8",
  null
  
)

export default component.exports